import { render } from "./RwsActivate.vue?vue&type=template&id=b175d8ba"
import script from "./RwsActivate.vue?vue&type=script&lang=js"
export * from "./RwsActivate.vue?vue&type=script&lang=js"

import exportComponent from "/home/vol4/node/projects/robonomics/robonomics-dapp-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__